import * as Data from './Data';

export default {
  Data,
};
